export const shouldFetchAccountLimits = ({ isEnterprise, isOnChatwootCloud }) =>
  Boolean(isEnterprise && isOnChatwootCloud);
